// Shows a free shipping threshold, set in the store currency, in the customer's currency.
// Rounds to the nearest whole unit, matching the free shipping bar in theme.js.
// A custom element so it also works in content loaded after the page (quick add, quick cart).
(function () {
  if (window.customElements.get("free-shipping-amount")) return;

  class FreeShippingAmount extends HTMLElement {
    connectedCallback() {
      var currency = window.Shopify && window.Shopify.currency;
      var amount = parseFloat(this.getAttribute("amount"));
      if (!currency || isNaN(amount)) return;

      var converted = Math.round(amount * (Number(currency.rate) || 1));

      this.textContent = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: currency.active,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(converted);
    }
  }

  window.customElements.define("free-shipping-amount", FreeShippingAmount);
})();
